export const TAGS_DATA_FETCH = '@@tags/FETCH_TAGS_DATA';
export const TAGS_DATA_SUCCESS = '@@tags/TAGS_DATA_SUCCESS';
export const TAGS_DATA_FAILURE = '@@tags/TAGS_DATA_FAILURE';

export const SELECT_TAG = '@@tags/SELECT_TAG';
export const SELECT_USERS = '@@tags/SELECT_USERS';
export const TOGGLE_ADD_TAG_DIALOG = '@@tags/TOGGLE_ADD_TAG_DIALOG';
export const CLEAR_USERS_SELECTION = '@@tags/CLEAR_USERS_SELECTION';

export const REMOVE_USERS_TAGS_TOGGLE = '@@tags/REMOVE_USERS_TAGS_TOGGLE';
export const REMOVE_USERS_TAGS_START = '@@tags/REMOVE_USERS_TAGS_START';
export const REMOVE_USERS_TAGS_SUCCESS = '@@tags/REMOVE_TAGS_SUCCESS';
export const REMOVE_USERS_TAGS_FAILURE = '@@tags/REMOVE_TAGS_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/tags/types.js